import { useEffect } from "react";
import { batch, useSignal, useComputed } from "@preact/signals-react";
import { useToastSeeker } from "@ui-seeker/app";
import { postSubmit } from "@ui-seeker/utils";

import { BACKEND_APIS } from "@constants";
import { commonFiltersValue, isLoadingCommonFilters } from "@signals";
import { calculateDiff } from "../@utils";
import { UserActivitiesIsEmpty, isLoadingCards } from "../@signals";


export default function useUserActivityCards(api) {
    const { showToast } = useToastSeeker()
    const data = useSignal({})
    const dataPrev = useSignal({})
    const isLoadingData = useSignal(false)
    const isLoadingDataPrev = useSignal(false)

    const isLoading = useComputed(() => isLoadingData.value || isLoadingDataPrev.value);
    const diff = useComputed(() => calculateDiff(data.value, dataPrev.value));

    useEffect(() => {
        isLoadingCards.value = isLoading.value;
    }, [isLoading.value]);

    useEffect(() => {
        if (isLoadingCommonFilters.value) {
            handleSubmit();
        }
    }, [isLoadingCommonFilters.value]);

    const handleSubmit = () => {
        if (!isLoadingData.value) {
            isLoadingData.value = true;
            postSubmit(`${BACKEND_APIS.ADMIN}/user-activities/cards/${api}`, commonFiltersValue.value )
                .then(({ data: res }) => {
                    batch(() => {
                        if (!res) {
                            UserActivitiesIsEmpty.value = true;
                            isLoadingCommonFilters.value = false;
                        } else {
                            data.value = res;
                        }
                    });
                })
                .catch(() => {
                    showToast.error();
                })
                .finally(() => {
                    isLoadingData.value = false;
                });
        }

        if (!isLoadingDataPrev.value) {
            isLoadingDataPrev.value = true;

            postSubmit(`${BACKEND_APIS.ADMIN}/user-activities/cards/${api}`, {...commonFiltersValue.value, isPrev: true})
                .then(({ data: res }) => {
                    batch(() => {
                        if (!res) {
                            isLoadingCommonFilters.value = false;
                        } else {
                            dataPrev.value = res;
                        }
                    });
                })
                .catch(() => {
                    showToast.error();
                })
                .finally(() => {
                    isLoadingDataPrev.value = false;
                });
        }
    };

    return {
        data: data.value,
        dataPrev: dataPrev.value,
        diff: diff.value,
    }
}
